<template>
    <div class="laskuri-block">
        <h2>{{ "App.LKPKannattavuuslaskuri.Header" | translate }}</h2>
        <p>{{ "App.LKPKannattavuuslaskuri.Guide" | translate }}</p>

        <div class="input-row">
            <label class="input-label full-width" for="basictaxPerDayInput">{{ "App.LKPKannattavuuslaskuri.BasixTaxLabel" | translate }}</label>
            <input id="basictaxPerDayInput" class="default full-width" type="text" v-model="basictaxPerDay" maxlength="5"/>
            <span class="input-suffix">{{ "App.LKPKannattavuuslaskuri.InputSuffix.Euro" | translate }}</span>
            <span class="invalid-input-message" v-if="invalidFields.basictaxPerDay">{{ invalidFields.basictaxPerDay }}<br /></span>
        </div>

        <div class="input-row">
            <label class="input-label full-width" for="powertaxPerDayInput">{{ "App.LKPKannattavuuslaskuri.PowerTaxLabel" | translate }}</label>
            <input id="powertaxPerDayInput" class="default full-width" type="text" v-model="powertaxPerDay" maxlength="5" />
            <span class="input-suffix">{{ "App.LKPKannattavuuslaskuri.InputSuffix.Euro" | translate }}</span>
            <span class="invalid-input-message" v-if="invalidFields.powertaxPerDay">{{ invalidFields.powertaxPerDay }}<br /></span>
            <span>{{ "App.LKPKannattavuuslaskuri.PowerTaxAdvice" | translate }} <router-link :to="{ name: 'Ajoneuvoverolaskuri', params: { cameFromLKPLaskuri: 'true' } }">{{ "App.LKPKannattavuuslaskuri.AjoneuvoverolaskuriRouterLinkText" | translate }}</router-link>)</span>
        </div>

        <div class="input-row">
            <label class="input-label full-width">{{ "App.LKPKannattavuuslaskuri.RegistrationTypeLabel" | translate }}</label>
            <label class="radio">
                <input type="radio" id="registrationTypeOffice" value="registrationTypeOffice" v-model="registrationType">
                <span for="registrationTypeOffice">{{ "App.LKPKannattavuuslaskuri.RegistrationType.Office" | translate }}</span>
            </label>
            <br />
            <label class="radio">
                <input type="radio" id="registrationTypeInternet" value="registrationTypeInternet" v-model="registrationType">
                <span for="registrationTypeInternet">{{ "App.LKPKannattavuuslaskuri.RegistrationType.Internet" | translate }}</span>
            </label>
            <p>({{ "App.LKPKannattavuuslaskuri.RegistrationTypeAdviceOffice" | translate }} {{ lkpConfigs.office }} {{ "App.LKPKannattavuuslaskuri.InputSuffix.Euro" | translate }} {{ "App.LKPKannattavuuslaskuri.RegistrationTypeAdviceInternet" | translate }} {{ lkpConfigs.internet }} {{ "App.LKPKannattavuuslaskuri.InputSuffix.Euro" | translate }})</p>
        </div>

        <div class="input-row">
            <label class="input-label full-width" for="trafficRemovalTimeInput">{{ "App.LKPKannattavuuslaskuri.TrafficRemovalTimeLabel" | translate }}</label>
            <input id="trafficRemovalTimeInput" class="default full-width" type="text" v-model="trafficRemovalTime" maxlength="4" />
            <span class="input-suffix">{{ "App.LKPKannattavuuslaskuri.InputSuffix.Days" | translate }}</span>
            <span class="invalid-input-message" v-if="invalidFields.trafficRemovalTime">{{ invalidFields.trafficRemovalTime }}<br /></span>
            <span>{{ "App.LKPKannattavuuslaskuri.TrafficRemovalTimeAdvice" | translate }}</span>
        </div>

        <div class="input-row">
            <label class="input-label full-width" for="insuranceAmountInput">{{ "App.LKPKannattavuuslaskuri.InsuranceAmountLabel" | translate }}</label>
            <input id="insuranceAmountInput" class="default full-width" type="text" v-model="insuranceAmount" maxlength="7"/>
            <span class="input-suffix">{{ "App.LKPKannattavuuslaskuri.InputSuffix.Euro" | translate }}</span>
            <span class="invalid-input-message" v-if="invalidFields.insuranceAmount">{{ invalidFields.insuranceAmount }}<br /></span>
            <span>{{ "App.LKPKannattavuuslaskuri.InsuranceAmountAdvice" | translate }}</span>
        </div>

        <div class="input-row">
            <label class="input-label full-width" for="fuelAmountInput">{{ "App.LKPKannattavuuslaskuri.FuelAmountLabel" | translate }}</label>
            <input id="fuelAmountInput" class="default full-width" type="text" v-model="fuelAmount" maxlength="4"/>
            <span class="input-suffix">{{ "App.LKPKannattavuuslaskuri.InputSuffix.LiterPerKm" | translate }}</span>
            <span class="invalid-input-message" v-if="invalidFields.fuelAmount">{{ invalidFields.fuelAmount }}<br /></span>
            <span>{{ "App.LKPKannattavuuslaskuri.FuelAmountAdvice" | translate }}</span>
        </div>

        <div class="input-row">
            <label class="input-label full-width" for="mileageAmountInput">{{ "App.LKPKannattavuuslaskuri.MileageAmountLabel" | translate }}</label>
            <input id="mileageAmountInput" class="default full-width" type="text" v-model="mileageAmount" maxlength="3"/>
            <span class="input-suffix">{{ "App.LKPKannattavuuslaskuri.InputSuffix.ThousandKm" | translate }}</span>
            <span class="invalid-input-message" v-if="invalidFields.mileageAmount">{{ invalidFields.mileageAmount }}<br /></span>
            <span>{{ "App.LKPKannattavuuslaskuri.MileageAmountAdvdice" | translate }}</span>
        </div>

        <div class="input-row">
            <label class="input-label full-width" for="fuelPriceInput">{{ "App.LKPKannattavuuslaskuri.FuelPriceLabel" | translate }}</label>
            <input id="fuelPriceInput" class="default full-width" type="text" v-model="fuelPrice" maxlength="4"/>
            <span class="input-suffix">{{ "App.LKPKannattavuuslaskuri.InputSuffix.EuroPerLiter" | translate }}</span>
            <span class="invalid-input-message" v-if="invalidFields.fuelPrice">{{ invalidFields.fuelPrice }}<br /></span>
            <span>{{ "App.LKPKannattavuuslaskuri.FuelPriceAdvice" | translate }}</span>
        </div>

        <div class="info-row">
            <label>{{ "App.LKPKannattavuuslaskuri.TakeNoticeLabel" | translate }}</label>
            <p id="takeNotice" class="takeNoticeText">{{ "App.LKPKannattavuuslaskuri.TakeNoticeText" | translate }}</p>
        </div>

        <button type="button" class="primary smallbutton results-button" v-on:click="calculateResults">{{ "App.LKPKannattavuuslaskuri.CalculateResultsButton" | translate }}</button>
        <button type="button" class="primary smallbutton empty-fields-button" v-on:click="emptyFields">{{ "App.LKPKannattavuuslaskuri.EmptyFieldsButton" | translate }}</button>

        <p class="invalid-input-message" v-if="missingFields">{{ "App.LKPKannattavuuslaskuri.MissingInfoText" | translate }}</p>
        <p>{{ "App.LKPKannattavuuslaskuri.Result.BenefitInfoText" | translate }} <span v-if="benefitAmount !== 0 && benefitCalculated">{{ benefitAmount.toFixed(2) }}</span> {{ "App.LKPKannattavuuslaskuri.InputSuffix.Euro" | translate }}</p>
        <div v-if="benefitCalculated">
            <p v-if="benefitAmount > 0">{{ "App.LKPKannattavuuslaskuri.Result.IsBeneficial" | translate }}</p>
            <p v-else-if="benefitAmount < 0">{{ "App.LKPKannattavuuslaskuri.Result.IsNotBeneficial" | translate }}</p>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator"
    import Validators from "../helpers/validators"
    import LKPKannattavuuslaskuriModel from "../models/lkpKannattavuuslaskuriModel"

    @Component
    export default class LKPKannattavuuslaskuri extends Vue {
        mounted(): void {
            this.$nextTick(async () => {
                const taxes: { basicTax: number; powerTax: number } = this.$store.getters.basicAndPowerTax
                if (taxes.basicTax != null && taxes.powerTax != null) {
                    this.basictaxPerDay = taxes.basicTax.toString()
                    this.powertaxPerDay = taxes.powerTax.toString()
                }
            })
        }

        // selected values: v-models
        basictaxPerDay: string = ""
        powertaxPerDay: string = ""
        registrationType: string = "registrationTypeOffice"
        trafficRemovalTime: string = ""
        insuranceAmount: string = ""
        fuelAmount: string = ""
        mileageAmount: string = ""
        fuelPrice: string = ""

        // result
        benefitAmount: number = 0
        benefitCalculated: boolean = false
        resultMessage: string = ""

        // invalid fields
        invalidFields: Array<object> = []
        missingFields: boolean = false

        get lkpConfigs(): LKPKannattavuuslaskuriModel {
            return this.$store.getters.lkpLaskuriConfigs
        }

        replaceCommaWithDecimalPoint(): void {
            this.basictaxPerDay = this.basictaxPerDay.replace(",", ".")
            this.powertaxPerDay = this.powertaxPerDay.replace(",", ".")
            this.trafficRemovalTime = this.trafficRemovalTime.replace(",", ".")
            this.insuranceAmount = this.insuranceAmount.replace(",", ".")
            this.fuelAmount = this.fuelAmount.replace(",", ".")
            this.mileageAmount = this.mileageAmount.replace(",", ".")
            this.fuelPrice = this.fuelPrice.replace(",", ".")
        }

        checkAllFieldsHaveValidValues(): boolean {
            // tarkista numerokentät
            let success = true
            let validated: boolean = false

            // muutetaan pilkut pisteiksi
            this.replaceCommaWithDecimalPoint()

            validated = Validators.validateFloatNumberField(this.basictaxPerDay)
            this.setInvalidField("basictaxPerDay", validated, this.basictaxPerDay)
            if (!validated) success = false

            validated = Validators.validateFloatNumberField(this.powertaxPerDay)
            this.setInvalidField("powertaxPerDay", validated, this.powertaxPerDay)
            if (!validated) success = false

            validated = Validators.validateFloatNumberField(this.trafficRemovalTime)
            this.setInvalidField("trafficRemovalTime", validated, this.trafficRemovalTime)
            if (!validated) success = false

            validated = Validators.validateFloatNumberField(this.insuranceAmount)
            this.setInvalidField("insuranceAmount", validated, this.insuranceAmount)
            if (!validated) success = false

            validated = Validators.validateFloatNumberField(this.fuelAmount)
            this.setInvalidField("fuelAmount", validated, this.fuelAmount)
            if (!validated) success = false

            validated = Validators.validateFloatNumberField(this.mileageAmount)
            this.setInvalidField("mileageAmount", validated, this.mileageAmount)
            if (!validated) success = false

            validated = Validators.validateFloatNumberField(this.fuelPrice)
            this.setInvalidField("fuelPrice", validated, this.fuelPrice)
            if (!validated) success = false

            return success
        }

        calculateResults(): void {
            if (!this.checkAllFieldsHaveValidValues()) {
                this.benefitCalculated = false
                this.missingFields = true
                this.$forceUpdate() // Jostain syystä ilman tätä dom ei päivity heti
                return
            }
            this.missingFields = false
            // Calculate results
            const usageTime: number = parseFloat(this.trafficRemovalTime)
            const insurances: number = parseFloat(this.insuranceAmount) / 365 * usageTime
            const taxes: number = (parseFloat(this.basictaxPerDay) + parseFloat(this.powertaxPerDay)) * usageTime
            const gas: number = (parseFloat(this.mileageAmount) * 10 * parseFloat(this.fuelPrice) * parseFloat(this.fuelAmount)) / 365 * usageTime

            let registrationPrice: number = 0
            if (this.registrationType === "registrationTypeOffice") {
                registrationPrice = parseFloat(this.lkpConfigs.office)
            } else {
                registrationPrice = parseFloat(this.lkpConfigs.internet)
            }

            this.benefitAmount = (insurances + taxes + gas) - registrationPrice
            if (this.benefitAmount < 0) {
                // ei kannata
                this.benefitCalculated = true
            } else {
                // kannattaa
                this.benefitCalculated = true
            }
        }

        emptyFields(): void {
            this.basictaxPerDay = ""
            this.powertaxPerDay = ""
            this.trafficRemovalTime = ""
            this.insuranceAmount = ""
            this.fuelAmount = ""
            this.mileageAmount = ""
            this.fuelPrice = ""

            // putsataan virheviestit
            this.invalidFields = []
            this.missingFields = false
            this.benefitAmount = 0
        }

        setInvalidField(fieldName: string, emptyMessage: boolean, fieldValue: string): void {
            if (!emptyMessage) {
                if (fieldValue === "") {
                    this.invalidFields[fieldName] = this.$t("App.LKPKannattavuuslaskuri.Fields.EmptyField")
                } else {
                    this.invalidFields[fieldName] = this.$t("App.LKPKannattavuuslaskuri.Fields.NumberFieldInvalid")
                }
            } else {
                this.invalidFields[fieldName] = ""
            }
        }
    }
</script>

    <style scoped>
        .laskuri-block {
            width: 100%;
            max-width: 1000px;
            padding: 20px 40px;
            background-color: rgb(242, 244, 248);
            text-align: left;
            border-top: 7px solid rgb(2, 98, 115);
        }
            .laskuri-block .input-row {
                margin-bottom: 15px;
            }
            .laskuri-block .full-width {
                width: 90%;
            }

            .invalid-input-message {
                color: red;
            }

        .takeNoticeText {
            white-space: pre-wrap;
        }

        .input-suffix {
            display: inline-block;
            padding-left: 10px;
            width: 10%;
        }

        .results-button {
            margin-right: 10px;
        }
    </style>
